declare namespace $ {

	type $shm_list_head__title_shm_projects_catalog_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__filter_shm_projects_catalog_2 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__add_shm_projects_catalog_3 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['add'] >
		,
		ReturnType< $shm_list_head['add'] >
	>
	type $shm_list_head__Close_shm_projects_catalog_4 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Close'] >
	>
	type $shm_list_head__Settings_shm_projects_catalog_5 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Settings'] >
	>
	type $shm_tree__roots_shm_projects_catalog_6 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_roots'] >
		,
		ReturnType< $shm_tree['roots'] >
	>
	type $shm_tree__children_shm_projects_catalog_7 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_children'] >
		,
		ReturnType< $shm_tree['children'] >
	>
	type $shm_tree__expanded_shm_projects_catalog_8 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_expanded'] >
		,
		ReturnType< $shm_tree['expanded'] >
	>
	type $shm_tree__Item_shm_projects_catalog_9 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['Project_link'] >
		,
		ReturnType< $shm_tree['Item'] >
	>
	type $mol_string__value_shm_projects_catalog_10 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['new_project_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_shm_projects_catalog_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_catalog_12 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['New_project_title'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_button_major__title_shm_projects_catalog_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_projects_catalog_14 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['new_project_create_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_projects_catalog_15 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['new_project_create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_projects_catalog_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_catalog_17 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['new_project_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_projects_catalog_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_speck__value_shm_projects_catalog_21 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_type'] >
		,
		ReturnType< $mol_speck['value'] >
	>
	type $mol_speck__style_shm_projects_catalog_22 = $mol_type_enforce<
		({ 
			'left': string,
			'right': string,
			'top': string,
		})  & ReturnType< $mol_speck['style'] >
		,
		ReturnType< $mol_speck['style'] >
	>
	type $mol_speck__attr_shm_projects_catalog_23 = $mol_type_enforce<
		({ 
			'aria-hidden': string,
		})  & ReturnType< $mol_speck['attr'] >
		,
		ReturnType< $mol_speck['attr'] >
	>
	type $mol_page__title_shm_projects_catalog_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__head_shm_projects_catalog_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__body_shm_projects_catalog_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__title_shm_projects_catalog_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_catalog_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_shm_projects_catalog_29 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_catalog_30 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_catalog_31 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_catalog_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $shm_projects_page__project_id_shm_projects_catalog_33 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_id'] >
		,
		ReturnType< $shm_projects_page['project_id'] >
	>
	export class $shm_projects_catalog extends $mol_book2 {
		catalog_pages( ): readonly(any)[]
		filter( next?: string ): string
		add( next?: any ): any
		List_head( ): $shm_list_head
		project_roots( ): readonly(any)[]
		project_children( id: any): readonly(any)[]
		project_expanded( id: any, next?: boolean ): boolean
		Projects( ): $shm_tree
		new_project_title( next?: string ): string
		New_project_title( ): $mol_string
		New_project_title_field( ): $mol_form_field
		new_project_create_enabled( ): boolean
		new_project_create( next?: any ): any
		New_project_create( ): $mol_button_major
		new_project_cancel( next?: any ): any
		New_project_cancel( ): $mol_button_minor
		New_project_actions( ): $mol_view
		New_project_form( ): $mol_view
		project_arg( id: any): Record<string, any>
		project_current( id: any): boolean
		project_title( id: any): string
		Project_title( id: any): $mol_view
		project_type( id: any): string
		Project_type( id: any): $mol_speck
		project_id( id: any): string
		projects_list_visible( next?: boolean ): boolean
		new_project_opened( next?: boolean ): boolean
		pages( ): ReturnType< $shm_projects_catalog['catalog_pages'] >
		Menu_page( ): $mol_page
		New_project_page( ): $mol_page
		Project_link( id: any): $mol_link
		Project( id: any): $shm_projects_page
	}
	
}

//# sourceMappingURL=catalog.view.tree.d.ts.map